import { render, staticRenderFns } from "./CapabilitiesManagerPage.vue?vue&type=template&id=266312dd"
import script from "./CapabilitiesManagerPage.vue?vue&type=script&lang=js"
export * from "./CapabilitiesManagerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports